// Feature component for displaying financial details

interface FinancialDetailsProps {
  caseId: string;
  invoicedAmount: number;
  reserveAmount: number;
  settlementAmount: number;
  paidAmount: number;
  onSuccess?: () => void;
  onCancel?: () => void;
  onUpdate?: () => void;
}

export function FinancialDetails({
  caseId,
  invoicedAmount,
  reserveAmount,
  settlementAmount,
  paidAmount,
  onSuccess,
  onCancel,
  onUpdate
}: FinancialDetailsProps) {
  
  return (
    <div className="mt-4 border-t border-gray-200 pt-4">
      <h3 className="flex items-center text-sm font-medium text-gray-700 mb-3">
        <span className="flex items-center justify-center w-5 h-5 bg-indigo-100 text-indigo-500 rounded-full mr-2">5</span>
        Financial Details
      </h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-xs text-gray-500">Invoiced Amount</div>
          <div className="font-medium">${invoicedAmount.toFixed(2)}</div>
        </div>
        
        <div>
          <div className="text-xs text-gray-500">Reserve Amount</div>
          <div className="font-medium">${reserveAmount.toFixed(2)}</div>
        </div>
        
        <div>
          <div className="text-xs text-gray-500">Settlement Amount</div>
          <div className="font-medium">${settlementAmount.toFixed(2)}</div>
        </div>
        
        <div>
          <div className="text-xs text-gray-500">Paid Amount</div>
          <div className="font-medium">${paidAmount.toFixed(2)}</div>
        </div>
      </div>
    </div>
  );
}
